import { Storage } from "aws-amplify";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Skeleton from 'react-loading-skeleton';
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { cloudfront_base_url } from '../../config/config';
import siteConfig from "../../config/site-config";
import { genericImageValidatorResizer } from '../../helper/CommonFunctions';
import ApiUrlServices from "../../networks/ApiUrlServices";
import AxiosServices from "../../networks/AxiosService";
import { userAction } from "../../store/userSlice";
import ModalBootstrap from '../modalBootstrap/ModalBootstrap';
import ImageCropper from './../../component/cropper/cropper';
import './ProfileSidebar.scss';
import Group from './static/Group.svg';

const ProfileSidebar = (props) => {
    const {t} = useTranslation();
    const foundRole = useSelector((state)=>state.userReducer.currentRole);
    const [currentRole,setCurrentRole] = useState(foundRole);
    const [role, setRole] = useState(foundRole !==null? foundRole : siteConfig.userRoles[0]);
    const getProfileData = useSelector((state) => state.userReducer.profileData);
    const dispatch = useDispatch();
    const [userSocial, setuserSocial] = useState({});
    const [userData, setUserData] = useState('');
    // Image Upload
    const [cardImage, setCardImage] = useState(null);
    const [profileImgLoading, setProfileImgLoading] = useState(false);
    const [uploadedPercentage, setUploadPercent] = useState(0);
    const [errorImage, setErrorImage] = useState("");
    const [imageProfile, setImageProfile] = useState({});
    const [cropImageModal, setCropImageModal] = useState(false);
    const [imageName, setImageName] = useState("");


    const inputRef = React.useRef();


    useEffect(() => {
        let sessionUserData = JSON.parse(localStorage.getItem('userData'));
        if(!sessionUserData) {
            return;
        }

        let pre_url = cloudfront_base_url;

        if (props.userData === undefined || props.userData === '') {
            sessionUserData !== null ? setUserData(sessionUserData) : setUserData({});
            (sessionUserData.profile_picture === undefined || sessionUserData.profile_picture === '') ? setCardImage(siteConfig.default_avatar) : setCardImage(pre_url + sessionUserData.profile_picture)
        } else {
            setUserData(props.userData);
            setCardImage(pre_url + props.userData.profile_picture)
            getProfileData.profile_picture === '' ? setCardImage(siteConfig.default_avatar) : setCardImage(pre_url + getProfileData.profile_picture)
        }
    }, [getProfileData])

    const onResizeImage = (image, name) => {
        setImageName(name);
        setImageProfile(image);
        setCropImageModal(true);
    }

    const handleImageUpload = async (e) => {
        let file = e

        let thumb_url = '';
        console.log("image", e)
        if (file !== undefined && file.name) {
            setProfileImgLoading(true)
            let pathUrl = `profile/${Date.now()}_${file.name}`;
            await Storage.put(pathUrl, file,
                {
                    progressCallback(progress) {
                        console.log(`Uploaded: ${Math.round(Number(progress.loaded / progress.total) * 100)}`);
                        setUploadPercent(Math.round(Number(progress.loaded / progress.total) * 100));
                    },
                })
                .then(res => {
                    console.log(res)
                    thumb_url = "public/" + res.key;
                }).catch(err => {
                    console.log(err)
                })

            let payload = {
                profile_picture: thumb_url
            }

            await AxiosServices.post(ApiUrlServices.PROFILE_PIC_UPDATE(userData.userId), payload, false)
                .then(res => {
                    console.log("profile picture", payload)
                    console.log(res)
                    setCardImage(URL.createObjectURL(e));
                    let x = JSON.parse(JSON.stringify(getProfileData));
                    x['profile_picture'] = thumb_url
                    dispatch(userAction.setProfileData(x));
                    userData['profile_picture'] = thumb_url
                    setUserData(userData)
                    localStorage.setItem('userData', JSON.stringify(userData))
                    setProfileImgLoading(false)
                    toast.success(`${t('ALL_MESSAGE.profile_image_updated_successfully')}`)
                })
                .catch(err => {
                    console.log(err)
                    setProfileImgLoading(false)
                    toast.error(`${t('ALL_MESSAGE.something_went_wrong')}`)
                })

        } else {
            return false
        }
    }


    useEffect(() => {
        setCurrentRole(foundRole);
    }, [foundRole]);
    
    const clickHandler = (e,name) => {
        e.preventDefault();
        setRole(name);
        dispatch(userAction.setRole(name));
    }

    useEffect(()=>{
        setuserSocial(getProfileData.social_links)
        console.log(userSocial)
    },[getProfileData.social_links])

    return(
        <>
        <div className="profile-sidebar-card">
            <div onClick={()=>props.setProfileMenuOpen(!props.profileMenuOpen)} className="mobile-toggle-menu">
                <i className={props.profileMenuOpen?"bi bi-x-lg":"bi bi-list"} />
            </div>
            <div className="thumb">
                {profileImgLoading?
                    <div className="" style={{
                        inset: "0px 0px 0px",
                        position: "absolute",
                        backgroundColor: "rgba(000, 000, 000, 0.5)"
                    }}>
                        <div style={{
                            position: "absolute",
                            top: " 50%",
                            left: "50%",
                            transform: "translateX(-50%) translateY(-50%)"
                        }}>
                            <div className="spinner-grow spinner-grow-lg text-primary"
                                 aria-hidden="false" aria-label="Loading"
                                 style={{fontSize: "40px"}}
                                 role="status"></div>
                        </div>
                    </div>
                    :null}
                {getProfileData?.profile_picture ?
                    <img src={`${cloudfront_base_url}${getProfileData?.profile_picture}`} alt={getProfileData.name} />
                :
                <img src={siteConfig.default_avatar} alt={getProfileData.name} />
                }
                <div className="overly-text">
                    <div className="overly-text-full">
                        <h4 className="name">{getProfileData?.name}</h4>
                        <span>{getProfileData?.profile_title}</span>
                    </div>
                </div>
                <div className="update-image">
                    <i onClick={() => {
                        inputRef.current.value = "";
                    }} className="fa-solid fa-pen-to-square">
                        <input id="file-input-image"
                               type="file"
                               onChange={e => {
                                   const config = {
                                       height: 192,
                                       width: 192
                                   }
                                   genericImageValidatorResizer(
                                       e.target.files[0],
                                       config,
                                       setErrorImage,
                                       false,
                                       handleImageUpload,
                                       false,
                                       e,
                                       onResizeImage
                                   )
                               }}
                               ref={inputRef}
                               accept="image/*"
                        />
                    </i>
                </div>

            </div>
            <div className="content-user-p">
                <div className="name-or-profile-title">
                    <h4 className="name">{getProfileData.name}</h4>
                    <span>{getProfileData.profile_title}</span>
                </div>
            {userSocial?
                <>
                <div className="social">
                    {userSocial.facebook ?
                        <span><a className="facebook" href={userSocial.facebook} target='__blank'><i className="fab fa-facebook-f" ></i></a></span>
                    :null}
                    {userSocial.twitter?
                        <span><a className="twitter" href={userSocial.twitter} target='__blank'><i className="fa-brands fa-x-twitter"/></a></span>
                    :null}
                    {userSocial.linkedin?
                        <span><a className="linkedin" href={userSocial.linkedin} target='__blank'><i className="fa-brands fa-linkedin" /></a></span>
                    :null}
                </div>
                </>
                :<Skeleton count={8} />
            }
            </div>
            
        </div>
        <div id="instructorApply"/>
        {/* <ApplyAsInstructor  /> */}
        {getProfileData.isMentorApproved === true ?
        <div className="select-instructor-role mt-30">
            <div className="select-intructor-role-full">
                <span><img src={Group} alt="student"/>
                {currentRole==="Student"?
                    <>{t('profile.student_profile')}</>
                    :<>{t('profile.instructor_profile')} </>
                }
                <i className="bi bi-chevron-down"/></span>
                <ul>
                    <li onClick={e=>{clickHandler(e,siteConfig.userRoles[1])}} >{t('profile.instructor_profile')}</li>
                    <li onClick={e=>{clickHandler(e,siteConfig.userRoles[0])}} >{t('profile.student_profile')}</li>
                </ul>
            </div>
        </div>
        :null}


            {
                cropImageModal ?
                    <ModalBootstrap
                        show={cropImageModal}
                        handleClose={setCropImageModal}
                        title="Resize image"
                        size={"md"}
                    >
                        <ImageCropper
                            inputRef={inputRef}
                            onClose={setCropImageModal}
                            imageFile={imageProfile}
                            imageName={imageName}
                            aspectRatio={1}
                            // cropShape="round"
                            cropImgSize={{ width: 284, height: 284 }}
                            callback={handleImageUpload}

                        />
                    </ModalBootstrap>
                    : null
            }


        </>
    )
}
export default ProfileSidebar;
